module.exports = __webpack_public_path__ + "static/media/Sample_OMR.80d438bf.png";